import React from 'react'
import TimelineWidget2 from './TimelineWidget2'
import timeline from '../json/timeline.json'

const SampleTimelineWidget2 = () => <TimelineWidget2 items={timeline} />

export default SampleTimelineWidget2
